import { api } from '@/api.js'

export default {
  state: {
    currentUser: {}
  },

  mutations: {
    FETCH_CURRENT_USER_SUCCESS(state, value) {
      state.currentUser = value
    },
    FETCH_CURRENT_USER_FAILURE(state) {
      state.currentUser = {}
    }
  },

  actions: {
    FETCH_CURRENT_USER_REQUEST({ commit }) {
      api.get('/profiles').then(({ data: { data } }) => {
        commit('FETCH_CURRENT_USER_SUCCESS', data)
      }).catch(() => {
        commit('FETCH_CURRENT_USER_FAILURE')
      })
    }
  }
}
